export default __webpack_public_path__ + "img/21.0ef00f.png";